import type { EinheitBereichKey } from '../../../../../components/immobilien/einheitWidgets';
import { AusstattungBereich } from './AusstattungBereich';
import { BankBereich } from './BankBereich';
import { DokumenteBereich } from './DokumenteBereich';
import { EigentuemerBereich } from './EigentuemerBereich';
import { FlaecheBereich } from './FlaecheBereich';
import { KaufBereich } from './KaufBereich';
import { KautionBereich } from './KautionBereich';
import { KontoBereich } from './KontoBereich';
import { MieteBereich } from './MieteBereich';
import { MieterBereich } from './MieterBereich';
import { MvBereich } from './MvBereich';
import { NotizBereich, ZaehlerBereich } from './EinfacheBereiche';
import { AktivitaetEinheit, EtvEinheit, MieterhoehungEinheit, SchluesselEinheit, TicketsEinheit, VersicherungEinheit, VertraegeEinheit, WartungEinheit } from './E8Bereiche';

/** Inhalt des Bereichs je Schlüssel. Nur angebundene Bereiche (ANGEBUNDENE_BEREICHE) werden geöffnet. */
export function BereichInhalt({ bereich }: { bereich: EinheitBereichKey }) {
  switch (bereich) {
    case 'mieter': return <MieterBereich />;
    case 'gesamt': return <MieteBereich fokus="entwicklung" />;
    case 'zus': return <MieteBereich fokus="zusammensetzung" />;
    case 'flaeche': return <FlaecheBereich />;
    case 'ausst': return <AusstattungBereich />;
    case 'mv': return <MvBereich />;
    case 'kaution': return <KautionBereich />;
    case 'konto': return <KontoBereich />;
    case 'bank': return <BankBereich />;
    case 'kauf': return <KaufBereich />;
    case 'eig': return <EigentuemerBereich fokus="eigentuemer" />;
    case 'hausgeld': return <EigentuemerBereich fokus="hausgeld" />;
    case 'zaehler': return <ZaehlerBereich />;
    case 'notiz': return <NotizBereich />;
    case 'docs': return <DokumenteBereich />;
    case 'tickets': return <TicketsEinheit />;
    case 'wartung': return <WartungEinheit />;
    case 'versich': return <VersicherungEinheit />;
    case 'vertraege': return <VertraegeEinheit />;
    case 'etv': return <EtvEinheit />;
    case 'keys': return <SchluesselEinheit />;
    case 'protokoll': return <AktivitaetEinheit />;
    case 'mieterh': return <MieterhoehungEinheit />;
    default: return null;
  }
}
